/**
 * Clerk's shadcn prebuilt theme sets `colorRing` and `colorModalBackdrop` to
 * `color-mix(...)`, which Clerk rejects in `appearance.variables` at runtime.
 * Use concrete colors aligned with `client/src/index.css` `--ring` (hsl(220, 91%, 54%)).
 */
export const clerkShadcnSafeColorVariables = {
  colorRing: "hsla(220, 91%, 54%, 0.5)",
  colorModalBackdrop: "rgba(0, 0, 0, 0.5)",
} as const;
